import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import ErrorMessage from '../ErrorMessage'

function Selectbox({
  data,
  label,
  options,
  className,
  materialDesign = true,
  onChange,
  hidden = false,
  ...rest
}) {
  const groupClasses = classNames('select-box', className, {
    'md-input-group': !!materialDesign,
    error: !!data.error,
  })
  const selectClasses = classNames('form-control', {
    'border-danger': !!data.error,
  })

  return (
    <div className={groupClasses} hidden={hidden || null}>
      <select
        className={selectClasses}
        name={data.name}
        value={data.value || ''}
        onChange={onChange}
        {...rest}
      >
        {options.map(({ label, disabled, value }, index) => {
          return (
            <option key={index} disabled={disabled || null} value={value}>
              {label}
            </option>
          )
        })}
      </select>

      {label && (
        <div className="label-box">
          <label className="float-above" htmlFor={data.name}>
            {label}
          </label>
        </div>
      )}

      <ErrorMessage message={data.error} />
    </div>
  )
}

Selectbox.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.any,
    error: PropTypes.any,
  }).isRequired,
  label: PropTypes.string,
  options: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.any.isRequired,
      disabled: PropTypes.bool,
    })
  ).isRequired,
  className: PropTypes.string,
  materialDesign: PropTypes.bool,
  onChange: PropTypes.func,
  hidden: PropTypes.bool,
}

export default Selectbox
export { default as selectboxVariants } from './variants'
